import React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import { Button, IconButton, Link, Stack, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import MenuIcon from "@mui/icons-material/Menu";
import {
    AdvertiseItems,
    ArticlesItem,
    LinkItem,
    PartnerItem,
    SmartStudioItem,
    SubscriptionsItem,
} from "./HeaderMenuLinks";
import { HeaderMenu } from "./HeaderMenu";
import { MobileHeaderMenu } from "./MobileHeaderMenu";
import { COLORS } from "../../theme";
import { SMARTBRIEF_ROOT } from "../constants";

export function AppHeader() {
    const [menuOpen, setMenuOpen] = React.useState<boolean>(false);

    const toggleNavMenu = () => {
        setMenuOpen(!menuOpen);
    };

    return (
        <AppBar position="sticky" aria-label="app header" data-testid={"app-header"} color={"inherit"} elevation={0}>
            <Toolbar>
                <Typography component="div" sx={{ flexGrow: 1 }} role={"heading"} aria-level={1}>
                    <Link
                        href={`${SMARTBRIEF_ROOT}`}
                        variant="h6"
                        underline="none"
                        className={"header-smartbrief-logo"}
                    />
                </Typography>
                <Box sx={{ flexGrow: 1 }} />
                <Stack direction={"row"} sx={{ display: { xs: "none", md: "flex" } }}>
                    <EmbeddedHeaderLink linkItem={SubscriptionsItem} />
                    <HeaderMenu title="Advertise" menuItems={AdvertiseItems} />
                    <EmbeddedHeaderLink linkItem={PartnerItem} />
                    <EmbeddedHeaderLink linkItem={ArticlesItem} />
                    <EmbeddedHeaderLink linkItem={SmartStudioItem} />
                </Stack>
                <Box sx={{ display: { xs: "flex", md: "none" } }}>
                    <IconButton size="large" aria-haspopup="true" onClick={toggleNavMenu} color="inherit">
                        {menuOpen ? <CloseIcon /> : <MenuIcon />}
                    </IconButton>
                </Box>
            </Toolbar>
            {menuOpen && (
                <Stack textAlign={"left"} sx={{ px: 4, py: 3 }}>
                    <MobileHeaderLink linkItem={SubscriptionsItem} />
                    <MobileHeaderMenu title="Advertise" menuItems={AdvertiseItems} />
                    <MobileHeaderLink linkItem={PartnerItem} />
                    <MobileHeaderLink linkItem={ArticlesItem} />
                    <MobileHeaderLink linkItem={SmartStudioItem} />
                </Stack>
            )}
        </AppBar>
    );

    function EmbeddedHeaderLink(props: { linkItem: LinkItem }) {
        return (
            <Button
                href={props.linkItem.href}
                variant={"text"}
                sx={{
                    mx: 3,
                    color: COLORS.SB_GREY,
                }}
                disableElevation
            >
                {props.linkItem.label}
            </Button>
        );
    }

    function MobileHeaderLink(props: { linkItem: LinkItem }) {
        return (
            <Link underline={"none"} href={props.linkItem.href} color={COLORS.SB_GREY} sx={{ my: 2, px: 1 }}>
                {props.linkItem.label}
            </Link>
        );
    }
}
